import React from 'react';
import "./CreationOrder.scss"
import { DragDropContext, Droppable, Draggable } from '@hello-pangea/dnd';
import {useGetPlaylistsQuery, useGetTemplatesQuery} from "../../../services/api";
import { useTranslation } from "react-i18next";
import {useDraggableInPortal} from "../../../components/Util/UseDraggableInPortal";
import {InformationTooltip} from "../../../components/InformationTooltip/InformationTooltip";

export default function CreationOrder({creationType, selectedCreationIds, setSelectedCreationIds}) {
    const { t } = useTranslation();
    const renderDraggable = useDraggableInPortal();


    /* ---- Data fetching ---- */
    const templatesQueryResult = useGetTemplatesQuery({pollingInterval: 3600000});
    const playlistsQueryResult = useGetPlaylistsQuery({pollingInterval: 3600000});

    let creationsQueryResult = null;
    if (creationType === 'template') {
        creationsQueryResult = templatesQueryResult;
    } else if (creationType === 'playlist') {
        creationsQueryResult = playlistsQueryResult;
    }

    const handleDragEnd = (param) => {
        if (!param.destination) {
            return; // Dropped outside Droppable
        }

        if (param.destination.droppableId === param.source.droppableId && param.destination.index === param.source.index) {
            return; // Dropped in same place
        }

        if (param.destination) {
            const srcI = param.source.index
            const desI = param.destination.index

            setSelectedCreationIds((current) => {
                current.splice(desI, 0, current.splice(srcI, 1)[0]);
                return current;
            });
        }
    };

    return (<>
        {selectedCreationIds.length >= 2 &&
            <div id="creation-order-container">
                <h3>
                    {creationType === 'template' && t('quick_publish.template_order.title')}
                    {creationType === 'playlist' && t('quick_publish.playlist_order.title')}

                    <InformationTooltip>
                        {
                            {
                                'template': t('quick_publish.template_order.info'),
                                'playlist': t('quick_publish.playlist_order.info'),
                            }[creationType]
                        }
                    </InformationTooltip>
                </h3>

                <DragDropContext onDragEnd={handleDragEnd}>
                    <Droppable droppableId="droppable">
                        {({ innerRef, droppableProps, placeholder }) => (
                            <div ref={innerRef} {...droppableProps}>
                                {selectedCreationIds.map((creationId, index) => {
                                    return creationsQueryResult.data.map((creation) => {
                                        if (creationId === creation.id) {
                                            return (
                                                <Draggable key={creation.id} draggableId={creation.id} index={index}>
                                                    {renderDraggable((provided) => (
                                                        <div
                                                            className="draggable-container"
                                                            ref={provided.innerRef}
                                                            {...provided.draggableProps}
                                                            {...provided.dragHandleProps}
                                                        >
                                                            <svg className="draggable-icon" fill="none" viewBox="0 0 24 24"><path stroke="#cccccc" strokeLinecap="round" strokeWidth="2" d="M4 18h16M4 12h16M4 6h16"/></svg>
                                                            {creation.name}
                                                        </div>
                                                    ))}
                                                </Draggable>
                                            )
                                        }
                                    });
                                })}
                                {placeholder}
                            </div>
                        )}
                    </Droppable>
                </DragDropContext>
            </div>
        }
    </>)
}
